import type { Accommodation, Meta } from '~/types/AccommodationSearch'
import type { Site } from '~/types/Site'

export const useGaSearchLocationViewAccommodation = (
  site: Site,
  accommodationMeta: Meta,
  availableAccommodations: Accommodation[]
) => {
  useGaSharedFunction.gtagEvent('search_location_view', {
    page_location_view: {
      type: 'ACCOMMODATION',
      parc: {
        id: site.meta.site?.id,
        name: site.name,
        location: {
          country: site.meta.country.name,
          region: site.meta.area.name,
        },
        price: {
          from: accommodationMeta.minPrice?.sellPrice,
        },
        accommodations: availableAccommodations.map((acc: Accommodation) => {
          return {
            aircon: acc.aircondition,
            beds: acc.bedrooms,
            discount: acc.priceBeforeDiscount - acc.priceAfterDiscount,
            id: acc.id,
            labels: acc.aircondition,
            name: acc.name,
            price: acc.priceBeforeFeesAfterDiscount,
          }
        }),
      },
    },
  })
}
